export default "__VITE_ASSET__CuJz28iA__"